import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChat = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 12,
					cy: 12,
					r: 1
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 16,
					cy: 12,
					r: 1
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 8,
					cy: 12,
					r: 1
				}),
				/* @__PURE__ */ _jsx("path", { d: "M19.07 4.93a10 10 0 00-16.28 11c.096.199.127.422.09.64L2 20.8a1 1 0 00.27.91A1 1 0 003 22h.2l4.28-.86a1.26 1.26 0 01.64.09 10 10 0 0011-16.28l-.05-.02zm.83 8.36a8 8 0 01-11 6.08 3.26 3.26 0 00-1.25-.26 3.43 3.43 0 00-.56.05l-2.82.57.57-2.82a3.09 3.09 0 00-.21-1.81 8 8 0 0113.032-8.762A8 8 0 0119.9 13.29z" })
			]
		})
	})
});
export { SvgChat as ReactComponent };
